import lang from "@/api/lang.js";
import { getCenterOfBounds } from "geolib";
import Vue from 'vue'

export async function getLangValue(section, nome, language) {

    var langValue = await lang.g(section + '_' + nome, language)

    return langValue.value
}

export function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

export async function haveLanguage(_lang) {
    var sameLang = 0
    _lang = Vue.lodash.lowerCase(_lang)

    var idiomas = await lang.getIdiomas()

    idiomas.map((idioma) => {
        if (idioma.idioma == _lang) {
            sameLang = sameLang + 1
        }
    })

    if (sameLang == 0) {
        return false
    } else {
        return true
    }
}

export async function getCentralMap(roteiro) {

    var _blocosPos = [];

    roteiro.blocos.map(bloco => {
        _blocosPos.push({
            latitude: bloco.bloco_lat,
            longitude: bloco.bloco_lon
        });
    });

    var centredBloco = getCenterOfBounds(_blocosPos);

    return centredBloco
}

export async function setHeaderTitle(title) {
    document.title = title
}


